import React from 'react';

function ConfigureKcompany() {
  return (
    <div>ConfigureKcompany</div>
  )
}

export default ConfigureKcompany;